import { tooltipComponentModule } from '../../../../shared/app/components/tooltip/tooltip';
import { landingTrackClickComponentModule } from '../track-click/track-click';
import frameworkDemosTemplate from './framework-demos.tpl.html';
import { appConfig } from '../../../../shared/app/constants/app-config';
import './framework-demos.less';

const defaultDemos = [
  { title: 'Ruby on Rails', icon: 'rails' },
  { title: 'Node.js', icon: 'nodejs' },
  { title: 'AngularJS', icon: 'angular' },
  { title: 'React', icon: 'react' },
  { title: 'MongoDB', icon: 'mongo' },
  { title: 'PostgreSQL', icon: 'postgresql' },
  { title: 'SQLite', icon: 'sqlite' },
  { title: 'Redis', icon: 'redis' },
];

export const frameworkDemosComponentModule = angular
  .module('Q.components.framework-demos', [
    tooltipComponentModule,
    landingTrackClickComponentModule,
  ])

  .directive('frameworkDemos', function ($http, $window, $document) {
    let demos = null;

    const linkBase = appConfig.assessRoute + '/';

    return {
      scope: {},
      restrict: 'E',
      template: frameworkDemosTemplate,
      link(scope) {
        const makeClickable = () => {
          scope.demos = demos;
          $document.find('html').addClass('has-live-demos');
        };

        if (demos) {
          makeClickable();
        } else {
          scope.demos = defaultDemos;
          $http.get(appConfig.apiRoot + 'assessments/demos').then((resp) => {
            demos = resp && resp.data && resp.data.data;
            if (demos) {
              demos.forEach((d) => {
                const galleryImage = d.galleryImage;
                d.backgroundImage = `url("${appConfig.cloudinaryBaseUrl}/${galleryImage.fileId}.${galleryImage.fileFormat}")`;
                d.link = linkBase + d.id;
              });
              makeClickable();
            }
          });
        }
      },
    };
  });
